import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';

class RoleTypes extends ChemComponent {
  	constructor(props) {
		super(props);
		
		var search = {
			TYPE_NAME: '',
			COMMENTS: ''
		};
		
		var initialRoleTypeList = this.copyRoleTypeList();
		initialRoleTypeList.query.search = this.constructSearch(search);
		
		this.state = {
			renderKey: 1,
			roleTypeList: initialRoleTypeList,
			search: search,
			searchCount: null
		};
	}
	
	copyRoleTypeList() {
		var roleTypeListCopy = this.copyObject(roleTypeList);
		for (var i = 0; i < roleTypeList.columns.length; i++) {
			if (roleTypeList.columns[i].Header) {
				roleTypeListCopy.columns[i].Header = roleTypeList.columns[i].Header;
			}
			if (roleTypeList.columns[i].Cell) {
				roleTypeListCopy.columns[i].Cell = roleTypeList.columns[i].Cell;
			}
		}
		return roleTypeListCopy;
	}
	
	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}
	
	onSubmitSearch(event) {
		var newRoleTypeList = this.copyRoleTypeList();
		newRoleTypeList.query.search = this.constructSearch(this.state.search);
		this.mergeState({ 
			roleTypeList: newRoleTypeList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
	
	constructSearch(data) {
		// construct search terms
		var search = {
			Operator: 'and',
			Children: []
		};

		if (!this.isEmpty(data.TYPE_NAME)) search.Children.push({ Attribute: 'TYPE_NAME', Operator: 'like', StringValue: '%' + data.TYPE_NAME + '%' });
		if (!this.isEmpty(data.COMMENTS)) search.Children.push({ Attribute: 'COMMENTS', Operator: 'like', StringValue: '%' + data.COMMENTS + '%' });
		
		// if nothing was selected, forget it
		if (search.Children.length === 0) search = null;
		return search;
	}
	
	addRoleType() {
		this.props.navigate('/BuildingAccess/RoleTypes/new');
	}
	
	editRoleType(roleTypeId) {
		this.props.navigate('/BuildingAccess/RoleTypes/' + roleTypeId);		
	}
	
	render() {

		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Role Types',
			columns: exportColumns,
			entity: 'ROLE_TYPES_VW',
			search: this.constructSearch(this.state.search),
			order: 'TYPE_NAME'
		});			

		return (<>
			<Container fluid>
				<Row>
				  <Col xs={12} style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
					<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Role Types</span>
					<ChemEdit parent={this} columns={roleTypeSearch} data={this.state.search} renderKey={this.state.renderKey} 
					  onChange={(accessor, value) => this.onChangeSearch(accessor, value)} onSubmit={(event) => this.onSubmitSearch(event)} {...this.props}>
					  <Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
						<Col xs={3} style={{ marginTop: 8}}>
							{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
								{exportData.map((excelFormField, index) => {
									return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
								{exportData.map((pdfFormField, index) => {
									return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={6}>
						  <Button id="update" variant="warning" type="submit" className="float-end">Search</Button>
						</Col>
					  </Form.Group>
					</ChemEdit>
				  </Col>
				</Row>
				<Row>
					<Col>
						<QueryTable renderKey={this.state.renderKey} parent={this} name='BuildingAccess_RoleTypes' table={this.state.roleTypeList}
							onResult={(data) => this.onSearchResult(data)} offsetHeight='200px' />
					</Col>
				</Row>
			</Container>
		</>);
	}
}

const roleTypeSearch = [
	{ Header: 'Name', accessor: 'TYPE_NAME', row: 0, col: 0 },
	{ Header: 'Comments', accessor: 'COMMENTS', row: 0, col: 1 }
];

const roleTypeList = {
	query: { entity: 'ROLE_TYPES_VW', search: null, order: 'TYPE_NAME' },
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addRoleType()} />, accessor: 'id', 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editRoleType(props.row.values.TYPE_ID)} />, width: 25 },
		{ Header: 'ID', accessor: 'TYPE_ID' },
		{ Header: 'Name', accessor: 'TYPE_NAME', width: 300 },
		{ Header: 'Abbreviation', accessor: 'TYPE_ABV' },
		{ Header: 'Directory', accessor: 'DIRECTORY_FLAG' },
		{ Header: 'Last Modified', accessor: 'MODIFIED', width: 300 },
		{ Header: 'Deleted', accessor: 'DELETE_FLAG' },
	]
};

const exportColumns = [
	{ Header: 'ID', accessor: 'TYPE_ID', width: 5 },
	{ Header: 'Name', accessor: 'TYPE_NAME', width: 15 },
	{ Header: 'Abbreviation', accessor: 'TYPE_ABV', width: 10 },
	{ Header: 'Directory', accessor: 'DIRECTORY_FLAG', width: 5 },
	{ Header: 'Last Modified', accessor: 'MODIFIED', width: 20 },
	{ Header: 'Deleted', accessor: 'DELETE_FLAG', width: 5 }
];

export default withRouter(RoleTypes);